export default __webpack_public_path__ + "static/media/Inter-Medium.d3da0838.woff";